var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeSsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.563 8.813h-1.69V4.957c0-2.734-2.27-4.958-5.062-4.958-2.792 0-5.063 2.224-5.063 4.958v3.854H5.062c-1.55 0-2.812 1.262-2.812 2.813v9.563C2.25 22.738 3.512 24 5.063 24h13.5c1.55 0 2.812-1.262 2.812-2.813v-9.562c0-1.55-1.262-2.813-2.813-2.813zm-9.94-3.855c0-1.7 1.43-3.083 3.188-3.083 1.757 0 3.187 1.383 3.187 3.083v3.854H8.623V4.958zM19.5 21.188c0 .516-.42.937-.938.937h-13.5c-.516 0-.937-.42-.937-.938v-9.562c0-.517.42-.938.938-.938h13.5c.516 0 .937.421.937.938v9.563z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M11.813 13.406c-.958 0-1.735.777-1.735 1.735 0 .611.317 1.149.795 1.457v2.058c0 .518.42.938.938.938s.937-.42.937-.938v-2.055c.48-.309.799-.847.799-1.46 0-.958-.777-1.735-1.735-1.735z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.73,
    x2: 8.96,
    y1: 19.337,
    y2: 15.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeSsl);
export default __webpack_public_path__ + "static/media/free-ssl.99c94c73b3b8f1253528e16df49f813c.svg";
export { ForwardRef as ReactComponent };